import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=014dd788&scoped=true"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=014dd788&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014dd788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014dd788')) {
      api.createRecord('014dd788', component.options)
    } else {
      api.reload('014dd788', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=014dd788&scoped=true", function () {
      api.rerender('014dd788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/MultiSelectionBadge/Wrapper.vue"
export default component.exports